import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";
import Config from "../../app/config/Config";

export default class MockApi {
    /**
     * 
     * @param {Config} config 
     */
    constructor(config) {
        this._environment = config.getValue(Config.ENVIRONMENT);
        this._isPlatformInterrupted = false;
        this._responseObject = {
            statusCode: "201"
        };
        this._initializationDelay = parseInt(getURLParameter('apiinitdelay') || 0);
        this._responseDelay = parseInt(getURLParameter('apitimeout') || 100);
        this._isTimeout = false;
    }

    async initialize() {
        if (getURLParameter("clear") === "1") {
            this.clearStorage();
        }

        if (this._initializationDelay) {
            await new Promise(resolve => setTimeout(resolve, this._initializationDelay));
        }

        window[PlatformAPIService.API_NAME] = this;
    }

    getGlobalConfigurationAsync() {
        const configuration = {
            language: getURLParameter("lang") ?? "en",
            play_mode: getURLParameter("mode") ?? "assessment",
            environment: this._environment,
        };

        console.log(`[MockAPI] getGlobalConfigurationAsync`);

        return new Promise(resolve => {
            setTimeout(() => resolve(configuration), this._responseDelay);
        });
    }

    getConfigurationAsync(appId) {
        const configuration = {
            language: getURLParameter("lang") ?? "en",
            interaction_state: this._loadState(appId),
            play_mode: getURLParameter("mode") ?? "assessment",
            environment: this._environment,
        };

        console.log(`[MockAPI] getConfigurationAsync: ${appId}`);

        return new Promise(resolve => {
            setTimeout(() => resolve(configuration), this._responseDelay);
        });
    }

    gameInterrupted(appId, payload) {
        if (this._isPlatformInterrupted) {
            return;
        }

        console.log(`[MockAPI] gameInterrupted ${appId}:`, payload);

        this._isPlatformInterrupted = true;
        alert(`[MockAPI] Game ${appId} interrupted by platform!\n\nReason:\n${JSON.stringify(payload, null, 2)}`);
        return;
    }

    sendEventAsync(eventType, payload) {
        console.log(`[MockAPI] sendEventAsync ${eventType}:`, eventType, payload || "no payload");
        switch (eventType) {
            case PlatformAPIEventType.SAVE_REQUEST:
                this._saveState(payload.app_id, payload.interaction_state);
                break;
        }
        return new Promise((resolve, reject) => setTimeout(_ => {
            if (this._isTimeout) {
                reject("MockAPI timeout");
            } else {
                resolve(this._responseObject);
            }
        }, this.responseDelay));
    }

    exit(appId) {
        console.log(`[MockAPI] exit: ${appId}`);

        this.clearStorage();
        window.location.reload();
    }

    setMockResponseObject(responseObject) {
        this._responseObject = responseObject;
    }

    setMockResponseDelay(responseDelay) {
        this._responseDelay = responseDelay;
    }

    setMockTimeoutState(isTimeout) {
        this._isTimeout = isTimeout;
    }

    clearStorage() {
        window.localStorage.clear();
    }

    _saveState(appId, str) {
        window.localStorage.setItem(this._getCookieName(appId), str);
    }

    _loadState(appId) {
        return window.localStorage.getItem(this._getCookieName(appId));
    }

    _getCookieName(appId) {
        return `${appId}.saveGame`;
    }
}